import styled from 'styled-components';

import { MessageMedium } from 'constants/messageMediums';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { EmailLine24, PushLine24, SmsLine24 } from 'ui/icons/aurora';
import {
  NavTabsListWithoutBorder,
  LinkNav,
  HalfGapTrigger,
} from 'modules/frequencyManagement/components/layout/TabsAndActions.styles';
import { FrequencyManagementUrl } from 'modules/frequencyManagement/lib/constants';
import { ExportCSV } from 'modules/frequencyManagement/components/layout/ExportCSV';

export const Wrapper = styled(FixedWidth)`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const TabsAndActions = () => (
  <Wrapper>
    <NavTabsListWithoutBorder aria-label="Manage your frequency settings">
      <LinkNav useReactRouter href={`${FrequencyManagementUrl}${MessageMedium.Email}`}>
        <HalfGapTrigger value={MessageMedium.Email}>
          <EmailLine24 />
          {MessageMedium.Email}
        </HalfGapTrigger>
      </LinkNav>
      <LinkNav useReactRouter href={`${FrequencyManagementUrl}${MessageMedium.Push}`}>
        <HalfGapTrigger value={MessageMedium.Push}>
          <PushLine24 />
          {MessageMedium.Push}
        </HalfGapTrigger>
      </LinkNav>
      <LinkNav useReactRouter href={`${FrequencyManagementUrl}${MessageMedium.SMS}`}>
        <HalfGapTrigger value={MessageMedium.SMS}>
          <SmsLine24 />
          {MessageMedium.SMS}
        </HalfGapTrigger>
      </LinkNav>
    </NavTabsListWithoutBorder>
    <ExportCSV />
  </Wrapper>
);
